module.exports = ".bg_page_sec.registration_page_sec {\n    background: transparent;\n}\n"